import React, {useEffect, useRef, useState, useContext} from 'react';
import firebase from 'firebase';

import * as dataManager from '../adapters/data';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';
import { GlobalContext } from '../contexts/GlobalContext';


const EditEmployeeModal = (props) => {

    const modalRef = useRef(null);

    const [edit, setEdit] = useState(true);

    const [state, setState] = useContext(GlobalContext);

    const [name, setName] = useState(state['editModal']? state['editModal'].name : '');
    const [qualifications, setQualifications] = useState([]);

    useEffect( () => {
        if (props.show) {
            modalRef.current.focus();
        }

    }, [props.show]
    );

    const editEmployee = () => {

        console.log(`Name: ${state['editModal'].name}`);
        console.log(state['editModal'].id);
        console.log('Employee Edited - ' + state['editModal'].id);
        props.onClose();

        dataManager.editEmployee(state['editModal'].id, state['editModal'].name, state['editModal'].qualifications);
        props.onEdit();

        
        
    }

    const updateName = (e) => {
        // setName(e.target.value);

        let editModal = state['editModal'];
        editModal.name = e.target.value;

        setState( (prevState) => {
            return {
                ...prevState, 
                editModal: editModal
            }
        });
    }
    
    const updateQuals = (e, data) => {
        setQualifications(data.value);
        console.log(data.value);

        let editModal = state['editModal'];
        editModal.qualifications = data.value.map( q => JSON.parse(q));

        setState( (prevState) => {
            return {
                ...prevState, 
                editModal: editModal
            }
        });
    }

    const cancelClose = () => {
        setName(state['editModal'].name);
        setQualifications(state['editModal'].qualifications);
        props.onClose();
    }

    const show = (show) => {
        props.show()
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show} role={`Edit ${props.name} dialog`}
            >
            <Modal.Header>Edit Employee</Modal.Header>
            <Modal.Content>
            {
                props.name? <Input style={{marginBottom: 10}} ref={modalRef} placeholder='Name' onChange={updateName} defaultValue={props.name}  /> :
                <Input style={{marginBottom: 10}} ref={modalRef} placeholder='Name' onChange={updateName} />
            }

            {
                props.qualifications ? <Dropdown
                fluid
                multiple
                search
                selection
                placeholder='Qualifications'
                options={state['qualifications'] ? state['qualifications'].map( (q) => ({key: q.id, text: q.name, value: JSON.stringify({id: q.id, name: q.name, qualifications: q.qualifications})} )) : []}
                onChange={updateQuals}
                defaultValue={props.qualifications.map( e => JSON.stringify(e))}
            />
                : <Dropdown
                fluid
                multiple
                search
                selection
                placeholder='Qualifications'
                options={state['qualifications'].map( (q) => ({key: q.id, text: q.name, value: JSON.stringify({id: q.id, name: q.name, qualifications: q.qualifications})} ) )}
                onChange={updateQuals}
            />
            }
                
            </Modal.Content>
            <Modal.Actions style={{display: 'flex', justifyContent: 'space-between'}}>
                <Button basic onClick={props.confirmDeleteCallback('employee', 'Delete Employee', ' employee?',state['editModal'] ? state['editModal'].name : '',state['editModal'] ? state['editModal'].id : '')}>Delete</Button>
                <div>
                    <Button basic onClick={cancelClose} >
                    Cancel
                    </Button>
                    <Button color='blue' disabled={state['editModal']?.name.trim() == ''? true : false} onClick={editEmployee} >
                    Save
                    </Button>
                </div>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default EditEmployeeModal;